import { Injectable } from '@angular/core';
import type { Glossary, GlossaryContributors, Tags, GlossaryEntry } from '../interfaces/glossaryInterface';
import * as glossaryJsonEn from './glossary_en.json';
import * as glossaryJsonDe from './glossary_de.json';
import * as contributorsJson from './glossary_contributors.json';

const GLOSSARY_EN: Glossary = glossaryJsonEn.glossary;
const GLOSASRY_DE: Glossary = glossaryJsonDe.glossary;

const CONTRIBUTORS: GlossaryContributors = contributorsJson.versions;

export interface GlossaryOptions {
    tagFilters: Tags;
    query?: string;
    primaryLanguage: 'en' | 'de';
    sortAscending: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class GlossaryService {

  get(options: GlossaryOptions = { 
      tagFilters: [], 
      primaryLanguage: 'en', 
      sortAscending: true,
    }) {
    const glossaryToUse = options.primaryLanguage === 'en' ? GLOSSARY_EN : GLOSASRY_DE;

    const matchEntries = (entries: GlossaryEntry[]) => {
      if (!options.query) return entries;
      
      const queryLower = options.query.toLowerCase();
      const results: GlossaryEntry[] = [];
      
      for (let i = 0; i < entries.length; i++) {
          const entry = entries[i];
          const primaryLower = entry.termPrimary.toLowerCase();
          const secondaryLower = entry.termSecondary.toLowerCase();
          
          if (primaryLower.startsWith(queryLower) || secondaryLower.startsWith(queryLower)) {
              results.push(entry);
              continue;
          }
          
          if (primaryLower.includes(queryLower) || secondaryLower.includes(queryLower)) {              
              if (primaryLower.split(' ').some(word => word.startsWith(queryLower)) ||
                  secondaryLower.split(' ').some(word => word.startsWith(queryLower))) {
                  results.push(entry);
              }
          }
      }
      
      return results;
    };
    const filterEntries = (entries: GlossaryEntry[]) => entries.filter(
        entry => options.tagFilters.every(tag => entry.tags.includes(tag))
    );
    const sortDescending = (glossary: Glossary) => (
      glossary.reverse().map(group => ({ ...group, entries: group.entries.reverse()}))
    );

    const partialGlossary = glossaryToUse.map(
        group => ({ ...group, entries: matchEntries(filterEntries(group.entries)) })
    ).filter(group => group.entries.length > 0);

    return options.sortAscending ? partialGlossary : sortDescending(partialGlossary);
  }

  getTags() {
    const tags = GLOSSARY_EN.flatMap(group => group.entries).flatMap(entries => entries.tags);
    return [...new Set(tags)];
  }

  getContributors() {
    return CONTRIBUTORS;
  }
}
